if (!customElements.get('video-player')) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      document.addEventListener('DOMContentLoaded', () => {
        this.video = this.querySelector('video');
        this.video.querySelector('img')?.setAttribute('alt', 'video player poster image.');
        const progressBarInner = this.querySelector('[data-progress-bar-inner]');
        const circularProgressBar = this.querySelector('[data-circular-progress-bar]');
        const radius = circularProgressBar?.r.baseVal.value;
        const circumference = 2 * Math.PI * radius;

        if (circularProgressBar) {
          circularProgressBar.style.strokeDasharray = `${circumference}`;
          circularProgressBar.style.strokeDashoffset = `${circumference}`;
        }

        const updateProgressBar = () => {
          const curr = (this.video.currentTime / this.video.duration) * 100;

          if (progressBarInner) {
            progressBarInner.style.width = `${curr}%`;
          }

          if (circularProgressBar) {
            const offset = circumference - (curr / 100) * circumference;
            circularProgressBar.style.strokeDashoffset = `${offset}`;
          }
        };

        this.video.addEventListener('timeupdate', updateProgressBar);

        this.video.addEventListener('ended', () => {
          this.setAttribute('data-state', 'ended');
          this.video.pause();
          this.video.load();

          if (progressBarInner) progressBarInner.style.width = null;
          if (circularProgressBar) circularProgressBar.style.strokeDashoffset = `${circumference}`;
        });
        
        if (this.dataset.autoplay === 'true') {
          this.video.muted = true;
          this.video.play().then(() => {
            this.setAttribute('data-state', 'playing');
          }).catch(() => {
            this.setAttribute('data-state', 'paused');
          });
        }
      });

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;

        const { action } = clickedElement.dataset;

        switch (action) {
          case 'play':
            this.video.muted = false;
            this.video.play();
            this.setAttribute('data-state', 'playing');
            break;
          case 'pause':
            this.video.pause();
            this.setAttribute('data-state', 'paused');
            break;
          default:
            break;
        }
      });
    }
  }

  customElements.define('video-player', VideoPlayer);
}
